// extracted by mini-css-extract-plugin
module.exports = {"labelActionBtn":"interests_labelActionBtn__1BCWI","labelActionIcon":"interests_labelActionIcon__1uCEm"};